import Section from './section'
import Layouts from './layouts'
import ErrorPage from './errorPage'
import Card from './card'
import ChildrenCard from './childrenCard'
import Status from './status'
import Jcele from '@/components/jcElement.js'
import Upload from './upload'
const components = [
  Section,
  Layouts,
  ErrorPage,
  Card,
  ChildrenCard,
  Status,
  Upload
]
const install = Vue => {
  if (install.installed) {
    return
  }
  Vue.use(Jcele)

  components.forEach(component => {
    Vue.component(component.name, component)
  })
}

export default {
  install
}
